import { VerificationFormData } from 'features/customerPanel/accountVerification/interface/verification';
import { FormikErrors, FormikTouched } from 'formik';
import { TFunction } from 'react-i18next';
import FormRow from 'shared/components/form/formRow';
import FormSubTitle from 'shared/components/form/formSubTitle';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';
import { isFieldValueValid } from 'shared/util/utility';
interface AccountVerificationFormStep1Props {
	t: TFunction<'translation'>;
	values: VerificationFormData;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	handleBlur: (e: React.FocusEvent<any>) => void;
	setFieldValue: (field: string, val: any) => void;
}

const AccountVerificationFormStep1 = ({ t, values, errors, touched, handleBlur, setFieldValue }: AccountVerificationFormStep1Props) => {
	const inputRef = useInputFocus();
	return (
		<>
			<FormSubTitle title={t('verificationStep2SubTitle')} />
			<FormRow>
				<InputText
					inputRef={inputRef}
					name="street"
					label={t('street')}
					onBlur={handleBlur}
					values={values}
					errors={errors}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					setFieldValue={setFieldValue}
					cyTestRef="street"
					cyErrorRef="validation-error"
				/>
			</FormRow>
			<FormRow>
				<InputText
					name="buildingNumber"
					label={t('buildingNumber')}
					values={values}
					onBlur={handleBlur}
					errors={errors}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					setFieldValue={setFieldValue}
					cyTestRef="building-number"
					cyErrorRef="validation-error"
				/>
				<InputText
					name="apartmentNumber"
					values={values}
					label={t('apartmentNumber')}
					onBlur={handleBlur}
					errors={errors}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					setFieldValue={setFieldValue}
					cyTestRef="apartment-number"
					cyErrorRef="validation-error"
				/>
			</FormRow>
		</>
	);
};
export default AccountVerificationFormStep1;
